import React, { useState, useEffect } from "react"
import { create_keyword_string } from "./utils"

export const VideoAd = ({
  ressort,
  adbutler_place,
  adbutler_page_id,
  tags = [],
  topic = "",
}) => {
  const set_id = {
    baumagazin: "33111",
    galabau: "33113",
    umweltbau: "33112",
  }
  const keyword_string = create_keyword_string({ tags, ressort, topic })

  const get_xml_src = () => {
    const xml_parser = new DOMParser()
    fetch(
      `https://servedbyadbutler.com/vast.spark?setID=${set_id[ressort]}&ID=169218&pageid=${adbutler_page_id}&place=${adbutler_place}&kw=${keyword_string}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.text()) // parse JSON from request
      .then((resultData) => {
        const xml_doc = xml_parser.parseFromString(resultData, "text/xml")

        const media_files = Array.from(
          xml_doc?.getElementsByTagName("MediaFile")
        )?.map(({ textContent }) => textContent)

        const click_through_link =
          xml_doc?.getElementsByTagName("ClickThrough")?.[0]?.textContent

        const impression_link =
          xml_doc?.getElementsByTagName("Impression")?.[0]?.textContent
        if (!!impression_link) {
          fetch(impression_link)
        }

        set_link_target(click_through_link)
        set_video_sources(media_files)
      })
      .catch((error) => console.log(error))
  }

  useEffect(() => {
    get_xml_src()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const [video_sources, set_video_sources] = useState([])
  const [link_target, set_link_target] = useState("")

  return !!video_sources?.[0] ? (
    <div
      className="ad-wrapper has-text-centered my-6 mx-auto my-6"
      style={{ maxWidth: 690 }}
    >
      <a target="_blank" rel="noopener noreferrer" href={link_target}>
        <video controls autoPlay loop muted playsInline>
          {video_sources?.map((src, index) => (
            <source
              {...{
                src,
                type: "video/mp4",
                key: `video-ad-src-${index}`,
              }}
            />
          ))}
        </video>
      </a>
      <div className="ad-disclaimer">Anzeige</div>
    </div>
  ) : null
}
